import { useCallback } from "react";
import { type To, useNavigate } from "react-router";

/**
 * Returns a stable callback that navigates to a given route while optionally attaching typed
 * `location.state`. Pair with parsers under `router-states/` and read state on
 * the destination with `useRouterState(parse…)`.
 *
 * Prefer `useNavigateWithRouterState` for feature hooks that need both
 * `navigate` and `getLinkProps` (see `useNavigateToEventDetails`).
 */
export function useNavigateWithState<T extends object>() {
	const navigate = useNavigate();
	return useCallback(
		(to: To, state?: T) => {
			navigate(to, { state });
		},
		[navigate],
	);
}
